import Signup from "./Signup";
import './signup.scss';

export default Signup;